/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChartPayloadFromJSON, ApiChartPayloadToJSON, } from './ApiChartPayload';
export function ApiChartRequestCSVPayloadFromJSON(json) {
    return ApiChartRequestCSVPayloadFromJSONTyped(json, false);
}
export function ApiChartRequestCSVPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiChartPayloadFromJSON(json['chart']),
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'lastNDays': !exists(json, 'lastNDays') ? undefined : json['lastNDays'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
    };
}
export function ApiChartRequestCSVPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiChartPayloadToJSON(value.chart),
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'lastNDays': value.lastNDays,
        'timezone': value.timezone,
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
    };
}
